import React, { useState, useEffect } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import api from '@/api';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import FloatingContact from '@/components/FloatingContact';
import SEOHead from '@/components/SEOHead';

const AboutPage = () => {
  const { lang, getLocalized } = useLanguage();
  const [page, setPage] = useState(null);
  const [products, setProducts] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [pageRes, productsRes, settingsRes] = await Promise.all([
          api.get('/pages/about'),
          api.get('/products'),
          api.get('/site-settings')
        ]);
        setPage(pageRes.data);
        setProducts(productsRes.data);
        setSettings(settingsRes.data);
      } catch (err) {
        console.error('Error:', err);
      }
    };
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  const loc = page ? getLocalized(page) : {};

  return (
    <div data-testid="about-page">
      <SEOHead
        title={lang === 'es' ? 'Sobre Nosotros' : 'About Us'}
        description={lang === 'es' ? 'Conozca Blackline Premium Solutions, proveedor premier de sistemas de ventanas y puertas en Texas.' : 'Learn about Blackline Premium Solutions, premier provider of modern window and door systems in Texas.'}
        path="/about"
      />
      <Navbar />
      <section className="bl-subpage-hero">
        <div className="bl-subpage-hero-bg" style={{ backgroundImage: `url(${loc.hero_image || ''})` }} />
        <div className="bl-subpage-hero-content">
          <div className="eyebrow">{lang === 'es' ? 'Empresa' : 'Company'}</div>
          <h1>{loc.title || 'About Blackline'}</h1>
        </div>
      </section>

      <div className="bl-info-content">
        <p>{loc.content || ''}</p>
        {loc.vision && (
          <>
            <h3 style={{ fontFamily: 'var(--font-serif)', fontSize: '1.5rem', marginBottom: '1rem', marginTop: '3rem' }}>
              {lang === 'es' ? 'Nuestra Visi\u00f3n' : 'Our Vision'}
            </h3>
            <p style={{ fontStyle: 'italic', color: 'var(--gold-dark)' }}>{loc.vision}</p>
          </>
        )}
      </div>

      {loc.principles && loc.principles.length > 0 && (
        <div className="bl-advantages-grid">
          {loc.principles.map((p, i) => (
            <div className="bl-advantage" key={i}>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
            </div>
          ))}
        </div>
      )}

      <Footer products={products} settings={settings} />
      <FloatingContact settings={settings} />
    </div>
  );
};

export default AboutPage;
